<nb-card class="preview-card">
  <nb-card-header>
    <div class="header-content">
      <div class="file-info">
        <nb-icon icon="file-text-outline"></nb-icon>
        <div>
          <h5 class="file-name">{{ previewInfo?.file_name || file?.file_name }}</h5>
          <p class="file-meta" *ngIf="fileSizeDisplay">{{ fileSizeDisplay }}</p>
        </div>
      </div>
      <div class="header-actions">
        <a *ngIf="previewInfo?.url" [href]="previewInfo.url" target="_blank" rel="noopener" download
          nbButton ghost size="small"
          nbTooltip="{{ 'buttons.download' | translate }}" nbTooltipPlacement="bottom">
          <nb-icon icon="download-outline"></nb-icon>
        </a>
        <button nbButton ghost (click)="close()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body class="preview-body">
    <!-- Loading -->
    <div *ngIf="loading" class="loading-state">
      <nb-spinner status="primary" size="large"></nb-spinner>
    </div>

    <!-- Error -->
    <div *ngIf="!loading && error" class="error-state">
      <nb-icon icon="alert-circle-outline" status="danger"></nb-icon>
      <p>{{ "panels.filePreview.loadError" | translate }}</p>
    </div>

    <!-- PDF -->
    <iframe
      *ngIf="!loading && !error && fileType === 'pdf'"
      [src]="safeUrl"
      class="pdf-frame"
      frameborder="0"
    ></iframe>

    <!-- Image -->
    <div *ngIf="!loading && !error && fileType === 'image'" class="image-preview">
      <img [src]="safeUrl" [alt]="previewInfo?.file_name" />
    </div>

    <!-- Text -->
    <div *ngIf="!loading && !error && fileType === 'text'" class="text-preview">
      <pre>{{ textContent }}</pre>
    </div>

    <!-- Office (Word, Excel, PowerPoint) via Microsoft Office viewer -->
    <iframe
      *ngIf="!loading && !error && fileType === 'office'"
      [src]="officeViewerUrl"
      class="pdf-frame"
      frameborder="0"
    ></iframe>

    <!-- Unsupported -->
    <div *ngIf="!loading && !error && fileType === 'unsupported'" class="unsupported-state">
      <nb-icon icon="file-outline"></nb-icon>
      <p>{{ "panels.filePreview.unsupported" | translate }}</p>
      <a [href]="previewInfo?.url" target="_blank" rel="noopener" nbButton status="primary" size="small">
        <nb-icon icon="download-outline"></nb-icon>
        {{ "buttons.download" | translate }}
      </a>
    </div>
  </nb-card-body>
</nb-card>
